import { OrderUnloading, UpdateOrderUnloadingPaylod } from "../../../../api/types/order"
import { regex } from "../../../../common/regex"
import { FormErrors } from "../../../FieldError"

export const validateUnloading = (data: UpdateOrderUnloadingPaylod): [boolean, FormErrors<OrderUnloading>] => {
  let isValid: boolean = true;
  let errors: FormErrors<OrderUnloading> = {}

  const { unloading } = data

  if (!unloading.name) {
    errors.name = "Název odesílatele je povinné pole."
    isValid = false
  }

  if (!unloading.street) {
    errors.street = "Ulice a číslo domu je povinné pole."
    isValid = false
  }

  if (!unloading.zip) {
    errors.zip = "PSČ je povinné pole."
    isValid = false
  }

  if (!unloading.city) {
    errors.city = "Obec je povinné pole."
    isValid = false
  }

  if (!unloading.country) {
    errors.country = "Stát je povinné pole."
    isValid = false
  }

  if (unloading.notifyPhone && !unloading.phone && !unloading.mobile) {
    errors.phone = "Telefon je povinné pole."
    isValid = false
  }

  if (unloading.notifySMS && !unloading.mobile) {
    errors.mobile = "Mobil je povinné pole."
    isValid = false
  } else if (unloading.notifyPhone && !unloading.phone && !unloading.mobile) {
    errors.mobile = "Mobil je povinné pole."
    isValid = false
  }

  if (unloading.notifyEmail && !unloading.email) {
    errors.email = "E-mail je povinné pole."
    isValid = false
  }

  if (unloading.email && !regex.email.test(unloading.email)) {
    errors.email = "E-mail je je ve špatném formátu."
    isValid = false
  }

  return [isValid, errors]
}

